import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// import ButtonBasic from '@/components/form/ButtonBasic.vue';
// import ToggleComponent from '@/components/form/ToggleComponent.vue';
//   import { ref } from 'vue';

export default {
  name: 'IntroVoice',
  components: {
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    this.calculateTotalPages();
    console.log('<<<<<<<<< IntroVoice mounted >>>>>>>>>');
    if (this.$store.state.selectedGalleryAvatar.isFemale) {
      this.actualVoiceList = this.femaleVoiceList;
    } else {
      this.actualVoiceList = this.maleVoiceList;
    }
  },
  methods: {
    calculateTotalPages: function calculateTotalPages() {
      if (this.$store.state.selectedGalleryAvatar.isFemale) {
        this.totalPages = Math.ceil(this.femaleVoiceList.length / this.itemsPerPage);
      } else {
        this.totalPages = Math.ceil(this.maleVoiceList.length / this.itemsPerPage);
      }
    },
    backButton: function backButton() {
      this.$store.commit('stopIntroPage', 'Voice');
      this.$store.commit('startIntroPage', 'AvatarViewer');
    },
    acceptVoice: function acceptVoice() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.$store.state.customerSelectedVoice || _this.$store.state.customerSelectedVoice == '')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return _this.$store.dispatch("saveProfileToDB");
            case 4:
              //if we are just saving a single setting 
              if (_this.$store.state.singleIntroSave === true || _this.$store.state.singleIntroSave === 'true') {
                console.log('truthy single intro save');
                _this.$store.commit('updatePreventIntroExperience', false);
                // this.$store.dispatch("saveProfileToDB", 'voice');
                _this.$store.commit('updateSingleIntroSave', false);
                _this.$store.commit('stopIntroPage', 'Voice');
              } else {
                console.log('falsey single intro save');
                //saving at the end so keep going (standard flow)
                _this.$store.commit('stopIntroPage', 'Voice');
                _this.$store.commit('startIntroPage', 'Personality');
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    playSample: function playSample(sampleIndex) {
      this.actualVoiceList.forEach(function (voice) {
        voice.playing = false;
      });
      var voiceList;
      if (this.$store.state.selectedGalleryAvatar.isFemale) {
        voiceList = this.femaleVoiceList;
      } else {
        voiceList = this.maleVoiceList;
      }
      console.log('play sample', voiceList[sampleIndex].filename);
      var myAudio = document.getElementById("myAudio");
      myAudio.src = voiceList[sampleIndex].filename;
      myAudio.play();
      // while playing set playing to true
      voiceList[sampleIndex].playing = true;
      // after audio stops set playing to false
      myAudio.onended = function () {
        voiceList[sampleIndex].playing = false;
      };
    },
    selectVoice: function selectVoice(voiceID) {
      this.actualVoiceList.forEach(function (voice) {
        voice.selected = false;
      });
      if (this.$store.state.selectedGalleryAvatar.isFemale) {
        //    set all voices to false

        this.femaleVoiceList.forEach(function (voice) {
          voice.selected = false;
        });
        // set selected voice to true
        this.femaleVoiceList[voiceID].selected = true;
        this.$store.commit('updateCustomerSelectedVoice', this.femaleVoiceList[voiceID].code);
      } else {
        //    set all voices to false
        this.maleVoiceList.forEach(function (voice) {
          voice.selected = false;
        });
        // set selected voice to true
        this.maleVoiceList[voiceID].selected = true;
        this.$store.commit('updateCustomerSelectedVoice', this.maleVoiceList[voiceID].code);
      }
    }
  },
  setup: function setup() {},
  data: function data() {
    return {
      itemsPerPage: 5,
      totalPages: 1,
      currentPage: 1,
      actualVoiceList: [],
      AudioFileToPlay: '/assets/audio/GirlResponse1.mp3',
      femaleVoiceList: [{
        label: 'British',
        filename: '/assets/audio/intro/09AoN6tYyW3VSTQqCo7C.mp3',
        selected: false,
        code: '09AoN6tYyW3VSTQqCo7C',
        playing: false
      }, {
        label: 'Litle Nerdy',
        filename: '/assets/audio/intro/2bk7ULW9HfwvcIbMWod0.mp3',
        selected: false,
        code: '2bk7ULW9HfwvcIbMWod0',
        playing: false
      }, {
        label: 'Vibrant',
        filename: '/assets/audio/intro/StXdHzik5guDrDk6fg3m.mp3',
        selected: false,
        code: 'StXdHzik5guDrDk6fg3m',
        playing: false
      }, {
        label: 'Mature',
        filename: '/assets/audio/intro/aTxZrSrp47xsP6Ot4Kgd.mp3',
        selected: false,
        code: 'aTxZrSrp47xsP6Ot4Kgd',
        playing: false
      }, {
        label: 'Slight Accent',
        filename: '/assets/audio/intro/eYO9Ven76ACQ8Me4zQK4.mp3',
        selected: false,
        code: 'eYO9Ven76ACQ8Me4zQK4',
        playing: false
      }, {
        label: 'soft',
        filename: '/assets/audio/intro/jGf6Nvwr7qkFPrcLThmD.mp3',
        selected: false,
        code: 'jGf6Nvwr7qkFPrcLThmD',
        playing: false
      }, {
        label: 'Lil Raspy n Mature',
        filename: '/assets/audio/intro/ug7mg45jVbzgYHpQBrw5.mp3',
        selected: false,
        code: 'ug7mg45jVbzgYHpQBrw5',
        playing: false
      }, {
        label: 'British',
        filename: '/assets/audio/intro/wJqPPQ618aTW29mptyoc.mp3',
        selected: false,
        code: 'wJqPPQ618aTW29mptyoc',
        playing: false
      }

      //    {
      //        label: 'Real (computed)',
      //        filename: '/assets/audio/intro/yqK28wCnkoKUmEGiXPMc.mp3',
      //        selected: false,
      //        code: 'yqK28wCnkoKUmEGiXPMc'
      //    },

      //    {
      //        label: 'LABEL',
      //        filename: '/assets/audio/intro/CODE.mp3',
      //        selected: false,
      //        code: 'CODE'
      //    },
      ],
      maleVoiceList: [{
        label: 'Loud Urban',
        filename: '/assets/audio/intro/Ybqj6CIlqb6M85s9Bl4n.mp3',
        selected: false,
        code: 'Ybqj6CIlqb6M85s9Bl4n',
        playing: false
      }, {
        label: 'Accent',
        filename: '/assets/audio/intro/j9jfwdrw7BRfcR43Qohk.mp3',
        selected: false,
        code: 'j9jfwdrw7BRfcR43Qohk',
        playing: false
      }, {
        label: 'Soothing',
        filename: '/assets/audio/intro/4JVOFy4SLQs9my0OLhEw.mp3',
        selected: false,
        code: '4JVOFy4SLQs9my0OLhEw',
        playing: false
      },
      // {
      //     label: 'Nerdy',
      //     filename: '/assets/audio/intro/wP7XBmkAmRwrjtfK2KeY.mp3',
      //     selected: false,
      //     code: 'wP7XBmkAmRwrjtfK2KeY',
      //     playing: false
      // },      
      // {
      //     label: 'Younger',
      //     filename: '/assets/audio/intro/7Nn6g4wKiuh6PdenI9wx.mp3',
      //     selected: false,
      //     code: '7Nn6g4wKiuh6PdenI9wx',
      //     playing: false
      // },      
      // {
      //     label: 'Late 20s',
      //     filename: '/assets/audio/intro/YCxeyFA0G7yTk6Wuv2oq.mp3',
      //     selected: false,
      //     code: 'YCxeyFA0G7yTk6Wuv2oq',
      //     playing: false
      // },      
      {
        label: 'Deep',
        filename: '/assets/audio/intro/4MWWPenmILmi7EhPD7ma.mp3',
        selected: false,
        code: '4MWWPenmILmi7EhPD7ma',
        playing: false
      }]
    };
  }
};